import { AxiosResponse } from 'axios';
import React from 'react';
import { useDownloadFile } from '../../hooks';
import { Button, ButtonProps } from '../Button/Button';

type Props = {
  apiDefinition: () => Promise<AxiosResponse<Blob>>;
  title: string;
  onError?: () => void;
  getFileName?: () => string;
  disabled?: boolean;
  onClick?: () => boolean;
} & Pick<ButtonProps, 'variant'>;

export const DownloadButton = (props: Props) => {
  const { apiDefinition, getFileName, title, onError, disabled = false, onClick, ...otherProps } = props;

  const { download, ref, url, name, request: fileDownloading } = useDownloadFile({
    apiDefinition,
    getFileName,
    onError
  });

  const handleClick = () => {
    if (onClick && onClick()) {
      download();
    } else if (!onClick) {
      download();
    }
  };

  return (
    <div>
      <a href={url} download={name} style={{ display: 'none' }} ref={ref}>link</a>
      <Button
        disabled={disabled}
        variant='filled'
        loading={fileDownloading}
        onClick={handleClick}
        {...otherProps}
      >
        {title}
      </Button>
    </div>
  );
};

export default DownloadButton;